<div class="container my-account-container d-flex">
  <div class="col-sm-12 col-md-12 col-lg-3 my-account-left-section endasureLeft">
    <app-airdisk-left></app-airdisk-left>
  </div>

  <div class="col-sm-12 col-md-12 col-lg-9 my-account-right-section endasureRight">
    @if (currentComponent === 'visitorInfo') {
      <app-airdisk-vistor-info></app-airdisk-vistor-info>
    }
    @if (currentComponent === 'fleetInfo') {
      <app-airdisk-fleet-info
        [adbDropDownData]="dropDownData?.drumToShoeReplacementFrequencyDropdown"
      ></app-airdisk-fleet-info>
    }
    @if (currentComponent === 'fleetSafety') {
      <app-airdisk-fleet-safety></app-airdisk-fleet-safety>
    }
    @if (currentComponent === 'frictionMaintainance') {
      <app-airdisk-friction-maintainance
        [adbDropDownData]="dropDownData?.brakeFrictionRequirementAtTradeInDropdown"
      ></app-airdisk-friction-maintainance>
    }
    @if (currentComponent === 'drumBreakCosts') {
      <app-airdisk-drum-break-costs></app-airdisk-drum-break-costs>
    }
    @if (currentComponent === 'csaViolationCosts') {
      <app-airdisk-csa-violation-costs></app-airdisk-csa-violation-costs>
    }
    @if (currentComponent === 'rustMaintainance') {
      <app-airdisk-rust-maintainance></app-airdisk-rust-maintainance>
    }
    @if (currentComponent === 'costSummary') {
      <app-airdisk-cost-summary
        [adbDropDownData]="dropDownData?.ADBImpactWithImprovedStoppingDistanceDropdown"
      ></app-airdisk-cost-summary>
    }
    @if (currentComponent === 'drumAdbSummary') {
      <app-airdisk-drum-summary></app-airdisk-drum-summary>
    }
  </div>
</div>
